import DesLCPrint from '../components/Certificate/DesLCPrint.vue';
import PrintLCTemplate from '../components/Certificate/PrintLCTemplate.vue';

const MngtHome2 = () => import(/* webpackChunkName: "mngt-home2" */'@/components/Management/Home2');

const MngtHome = () => import(/* webpackChunkName: "mngt-home" */'@/components/Management/Home');
const MngtByPass = () => import(/* webpackChunkName: "mngt-by-pass" */'@/components/Management/MngtByPass');
const MngtFacultyBypass = () => import(/* webpackChunkName: "mngt-faculty-by-pass" */'@/components/Management/MngtFacultyBypass');
const Attendance_Report = () => import(/* webpackChunkName: "attendance-report" */'@/components/Management/Academics/Attendance_Report');
const User_Report = () => import(/* webpackChunkName: "user-report" */'@/components/Management/Academics/User_Report');
const Academics_Dashboard = () => import(/* webpackChunkName: "academics-dashboard" */'@/components/Management/Academics/Academics_Dashboard');
const MngtLogin = () => import(/* webpackChunkName: "mngt-login" */'@/components/Management/MngtLogin');
const MngtRedirect = () => import(/* webpackChunkName: "mngt-redirect" */'@/components/Management/MngtRedirect');
const PaymentDailyTransactionReport = () => import(/* webpackChunkName: "payment-daily-transaction-report" */'@/components/Management/AccountingAndFees/PaymentDailyTransactionReport');
const InstallmentDueReport = () => import(/* webpackChunkName: "installment-due-report" */'@/components/Management/AccountingAndFees/InstallmentDueReport');
const FineDetailedReport = () => import(/* webpackChunkName: "installment-due-report" */'@/components/Management/AccountingAndFees/FineDetailedReport');
const ManagementEmployeeLeaveBalanceReport = () => import(/* webpackChunkName: "management-employee-leave-balance-report" */'@/components/Management/EmployeeLeave/ManagementEmployeeLeaveBalanceReport');
const ApproveLeave = () => import(/* webpackChunkName: "approve-leave" */'@/components/Management/EmployeeLeave/ApproveLeave');
const ManagementInstructorReport = () => import(/* webpackChunkName: "management-instructor-report" */'@/components/Management/Academics/ManagementInstructorReport');
const ManagementInstStructureReport = () => import(/* webpackChunkName: "management-instructure-report" */'@/components/Management/Academics/ManagementInstStructureReport');
const PrePrimaryStudentReportCard = () => import(/* webpackChunkName: "pre-primary-student-report-card" */'@/components/Management/Academics/PrePrimaryStudentReportCard');
const ManagementInstallmentDetailedReport = () => import(/* webpackChunkName: "management-installment-detailed-report" */'@/components/ZealExamination/AccountingAndFees/ManagementInstallmentDetailedReport');
const ManagementSectionSummaryReport = () => import(/* webpackChunkName: "management-section-summary-report" */'@/components/ZealExamination/AccountingAndFees/ManagementSectionSummaryReport');
const ManagementAccountDashboard = () => import(/* webpackChunkName: "management-account-dashboard" */'@/components/ZealExamination/AccountingAndFees/ManagementAccountDashboard');
const PrimaryReportCard = () => import(/* webpackChunkName: "primary-report-card" */'@/components/Management/Academics/PrimaryReportCard');
const DivTimeTable = () => import(/* webpackChunkName: "div-time-table" */'@/components/Management/TimeTable/DivTimeTable');
const FacultyTimeTable = () => import(/* webpackChunkName: "faculty-time-table" */'@/components/Management/TimeTable/FacultyTimeTable');
const FacultyTimeTable1 = () => import(/* webpackChunkName: "faculty-time-table1" */'@/components/TimeTable/FacultyTimeTable');
const GetWeakTTReport = () => import(/* webpackChunkName: "get-weak-TT-report" */'@/components/Management/TimeTable/GetWeakTTReport');
const SbppsAnnualMS = () => import(/* webpackChunkName: "sbpps-annual-MS" */'@/components/Examination/Admin/AnnualMarksheet')
const SbppsAnnualMS2 = () => import(/* webpackChunkName: "sbpps-annual-MS2" */'@/components/Examination/Admin/AnnualMarksheet2')


const WWSBonafiedPrint = () => import(/* webpackChunkName: "wws-bonafied-print" */'@/components/Certificate/WWSBonafiedPrint');

const SbppsLearnetMarksheetOfAdmin = () => import(/* webpackChunkName: "sbpps-learnet-marksheet-of-admin" */'@/components/Examination/Admin/LearnetMarksheetOfAdmin');
const SbppsLearnetMarksheetOfParent = () => import(/* webpackChunkName: "sbpps-learnet-marksheet-of-parent" */'@/components/Examination/Admin/Parent_Lerner_Marksheet');
const ParentLearnerMarksheetHSC = () => import(/* webpackChunkName: "parent-learner-marksheet-hsc" */'@/components/Examination/Admin/ParentLearnerMarksheetHSC');
const SbppsLearnetMarksheetOfParentPrePrimary = () => import(/* webpackChunkName: "sbpps-learner-marksheet-of-parent-pre-primary" */'@/components/Examination/Admin/PrePrimaryMarksheetParent');
const SbppsAnnualReportSecondary = () => import(/* webpackChunkName: "sbpps-annual-report-secondary" */'@/components/Examination/Admin/AnnualReportSecondary');
const AnnualReportSecondary_22_23 = () => import(/* webpackChunkName: "annual-report-secondary-22-23" */'@/components/Examination/Admin/AnnualReportSecondary_22_23');
const AnnualReportXI = () => import(/* webpackChunkName: "annual-report-XI" */'@/components/Examination/Admin/AnnualReportXI');
const LearnerMarksheetHSC = () => import(/* webpackChunkName: "learner-marksheet-hsc" */'@/components/Examination/Admin/LearnerMarksheetHSC');
const SbppsAnnualReportPrePrimary = () => import(/* webpackChunkName: "sbpps-annual-report-pre-primary" */'@/components/Examination/Admin/PrePrimaryMarksheetAnnual');
const SbppsAnnualReportPrePrimary2 = () => import(/* webpackChunkName: "sbpps-annual-report-pre-primary2" */'@/components/Examination/Admin/PrePrimaryMarksheetAnnual2');

const SbppsReportPrePrimary = () => import(/* webpackChunkName: "sbpps-report-pre-primary" */'@/components/Examination/Admin/PrePrimaryMarksheet');
const LearnerMarksheetInfoZeal = () => import(/* webpackChunkName: "learner-marksheet-info-zeal" */'@/components/ZealExamination/Admin/LearnerMarksheetInfo');
//////////////////////////////////
const ViewForm = () => import(/* webpackChunkName: "view-form" */'@/components/Admission/ViewForm');
const AddVisitor = () => import(/* webpackChunkName: "add-visitor" */'@/components/VisitorMngt/Outsider/AddVisitor');
const VisitorEPass = () => import(/* webpackChunkName: "visitor-pass" */'@/components/VisitorMngt/Outsider/VisitorEPass');
const SendtomailEpass = () => import(/* webpackChunkName: "visitor-pass" */'@/components/VisitorMngt/Outsider/SendtomailEpass');
const CapturePhoto = () => import(/* webpackChunkName: "capture-photo" */'@/components/VisitorMngt/User/CapturePhoto');
/////////Icard Print
const ZealInstructorCardPrint = () => import(/* webpackChunkName: "zeal-instructor-card-print" */'@/components/Icard/ZealInstructorCardPrint');
const CommonInstructorIcardPrint = () => import(/* webpackChunkName: "inst-card-print" */'@/components/Icard/CommonInstructorIcardPrint');
const TMVInstructorIcardPrint = () => import(/* webpackChunkName: "tmv-inst-card-print" */'@/components/Icard/TMVInstructorIcardPrint');
const SanjivaniStudentBulkIcardPrint = () => import(/* webpackChunkName: "sanjivani-student-bulk-card-print" */'@/components/Icard/SanjivaniStudentBulkIcardPrint');
const SanjivaniInstructorCardPrint = () => import(/* webpackChunkName: "sanjivani-inst-card-print" */'@/components/Icard/SanjivaniInstructorCardPrint');
const SbppsStudentBulkIcardPrint = () => import(/* webpackChunkName: "sbpps-student-bulk-card-print" */'@/components/Icard/SbppsStudentBulkIcardPrint');
const SbppsInstructorBulkIcardPrint = () => import(/* webpackChunkName: "sbpps-inst-bulk-card-print" */'@/components/Icard/SbppsInstructorBulkIcardPrint');
const SbppsInstructorSpecificIcardPrint = () => import(/* webpackChunkName: "sbpps-inst-specific-card-print" */'@/components/Icard/SbppsInstructorSpecificIcardPrint');
const ZealLCPrint = () => import(/* webpackChunkName: "zeal-LC-print" */'@/components/Certificate/ZealLCPrint');
const VvpLCPrint = () => import(/* webpackChunkName: "vvp-LC-print" */'@/components/Certificate/VvpLCPrint');
const WWSLCPrint = () => import(/* webpackChunkName: "wws-LC-print" */'@/components/Certificate/WWSLCPrint');

const SakLCPrint = () => import(/* webpackChunkName: "sak-lc-print" */'@/components/Certificate/SakLCPrint');
const SavLCPrint = () => import(/* webpackChunkName: "sav-lc-print" */'@/components/Certificate/SavLCPrint');
const SjcvLCPrint = () => import(/* webpackChunkName: "sjcv-lc-print" */'@/components/Certificate/SjcvLCPrint');
const SjckLCPrint = () => import(/* webpackChunkName: "sjck-lc-print" */'@/components/Certificate/SjckLCPrint');
const SsjcLCPrint = () => import(/* webpackChunkName: "ssjc-lc-print" */'@/components/Certificate/SsjcLCPrint');
const SisLCPrint = () => import(/* webpackChunkName: "sis-lc-print" */'@/components/Certificate/SisLCPrint');
const SbppsLCPrint = () => import(/* webpackChunkName: "sbpps-LC-print" */'@/components/Certificate/SbppsLCPrint');
const EPSLCPrint = () => import(/* webpackChunkName: "eps-LC-print" */'@/components/Certificate/EPSLCPrint');
const BulkLCTemplatePrint = () => import(/* webpackChunkName: "bulk-LC-print" */'@/components/Certificate/BulkLCTemplatePrint');
const ZealStudentSpecificICardPrint = () => import(/* webpackChunkName: "zeal-student-Icard-print" */'@/components/Icard/ZealStudentSpecificICardPrint');
const SbppsParentSpecificIcardPrint = () => import(/* webpackChunkName: "sbpps-specific-parent-card-print" */'@/components/Icard/SbppsParentSpecificIcardPrint');
const SanjivaniStudentSpecificIcardPrint = () => import(/* webpackChunkName: "sanjivani-specific-Icard-print" */'@/components/Icard/SanjivaniStudentSpecificIcardPrint');
const UwwsStudentBulkIcardPrint = () => import(/* webpackChunkName: "uwws-bulk-icard-print" */'@/components/Icard/UwwsStudentBulkIcardPrint');
const UwwsStudentSpecificIcardPrint = () => import(/* webpackChunkName: "uwws-specific-card-print" */'@/components/Icard/UwwsStudentSpecificIcardPrint');
const UwwsParentBulkIcardPrint = () => import(/* webpackChunkName: "uwws-parent-bulk-card-print" */'@/components/Icard/UwwsParentBulkIcardPrint');
const UwwsParentSpecificIcardPrint = () => import(/* webpackChunkName: "uwws-parent-specific-card-print" */'@/components/Icard/UwwsParentSpecificIcardPrint');
const WwsStudentEscortPrint = () => import(/* webpackChunkName: "wws-student-escort-print" */'@/components/Icard/WwsStudentEscortPrint');
const WwsFatherIcardPrint = () => import(/* webpackChunkName: "wws-father-icard-print" */'@/components/Icard/WwsFatherIcardPrint');
const WwsMotherIcardPrint = () => import(/* webpackChunkName: "wws-mother-icard-print" */'@/components/Icard/WwsMotherIcardPrint');
const WwsStudentBulkIcardPrint = () => import(/* webpackChunkName: "wws-stud-new-bulk-card-print" */'@/components/Icard/WwsStudentBulkIcardPrint');
const VVPStudentBulkIcardPrint = () => import(/* webpackChunkName: "vvp-student-bulk-Icard-print" */'@/components/Icard/VVPStudentBulkIcardPrint');
const WwsStudentSpecificIcardPrint = () => import(/* webpackChunkName: "wws-stud-new-specific-card-print" */'@/components/Icard/WwsStudentSpecificIcardPrint');
const SbppsStudentSpecificIcardPrint = () => import(/* webpackChunkName: "sbpps-stud-specific-card-print" */'@/components/Icard/SbppsStudentSpecificIcardPrint');
const VVPStudentSpecificIcardPrint = () => import(/* webpackChunkName: "vvp-student-specific-Icard-print" */'@/components/Icard/VVPStudentSpecificIcardPrint');
const SbppsParentBulkIcardPrint = () => import(/* webpackChunkName: "sbpps-bulk-parent-card-print" */'@/components/Icard/SbppsParentBulkIcardPrint');
const TMVStudentSpecificIcardPrint = () => import(/* webpackChunkName: "tmv-specific-card-print" */'@/components/Icard/TMVStudentSpecificIcardPrint');
const TMVStudentBulkIcardPrint = () => import(/* webpackChunkName: "tmv-bulk-icard-print" */'@/components/Icard/TMVStudentBulkIcardPrint');

const ZealInstructorBulkIcard = () => import(/* webpackChunkName: "zeal-instructor-bulk-Icard" */'@/components/Icard/ZealInstructorBulkIcard');
const SanjivaniInstructorBulkIcard = () => import(/* webpackChunkName: "zeal-instructor-bulk-Icard" */'@/components/Icard/SanjivaniInstructorBulkIcard');
const ZealStudentBulkICardPrint = () => import(/* webpackChunkName: "zeal-student-bulk-Icard-print" */'@/components/Icard/ZealStudentBulkICardPrint');
const WwsStudentBulkEscortPrint = () => import(/* webpackChunkName: "wws-student-bulk-escort-print" */'@/components/Icard/WwsStudentBulkEscortPrint');
//healthcard
const StudentHealthCard = () => import(/* webpackChunkName: "student-health-card" */'@/components/HealthCard/StudentHealthCard');
//const MobileShare = () => import(/* webpackChunkName: "mobile-share" */'@/components/LiveClass/MobileShare');
const HallticketBulkPrintSJCK = () => import(/* webpackChunkName: "hallticket-bulk-print" */'@/components/Examination/HallticketBulkPrintSJCK');

/////
const NotFound = () => import(/* webpackChunkName: "not-found" */'@/components/NotFound');
const S2T = () => import(/* webpackChunkName: "S2T" */'@/components/TryNError/SpeechToText');
const CSS = () => import(/* webpackChunkName: "S2T" */'@/components/TryNError/CSS');
const LearnerMarksheetIsceITOIII = () => import(/* webpackChunkName: "marksheet-icse-I-III" */'@/components/WWSExamination/Admin/LearnerMarksheetIsceITOIII');
const MarksheetICSE = () => import(/* webpackChunkName: "marksheet-icse" */'@/components/WWSExamination/Admin/MarksheetICSE');
const LearnerMarksheetPrePrimIcsePrint = () => import(/* webpackChunkName: "learner-marksheet-icse-pre-prim-print" */'@/components/WWSExamination/Admin/LearnerMarksheetPrePrimIcsePrint');
const LearnerAnnualMarksheetPrePrimIcseView = () => import(/* webpackChunkName: "learner-marksheet-icse-pre-prim-view" */'@/components/WWSExamination/Admin/LearnerAnnualMarksheetPrePrimIcseView');
const LearnerAnnualMarksheetPrePrimIcsePrint = () => import(/* webpackChunkName: "learner-annual-marksheet-icse-pre-prim-print" */'@/components/WWSExamination/Admin/LearnerAnnualMarksheetPrePrimIcsePrint');
const LearnerMarksheetMarathiPrint = () => import(/* webpackChunkName: "wws-marathi-print" */'@/components/WWSExamination/Admin/LearnerMarksheetMarathiPrint');
const LearnerMarksheetIcscAnnualPrint = () => import(/* webpackChunkName: "wws-icsc-annual-print" */'@/components/WWSExamination/Admin/LearnerMarksheetIcscAnnualPrint');
const LearnerMarksheetIcscAnnualPrint_2 = () => import(/* webpackChunkName: "wws-icsc-annual-print-2" */'@/components/WWSExamination/Admin/LearnerMarksheetIcscAnnualPrint_2');
const LearnerAnnualMarksheetView = () => import(/* webpackChunkName: "wws-icsc-annual-view" */'@/components/WWSExamination/Admin/LearnerAnnualMarksheetView');
const LearnerAnnualMarksheetView_I_III = () => import(/* webpackChunkName: "wws-icsc-annual-view-I-III" */'@/components/WWSExamination/Admin/LearnerAnnualMarksheetView_I_III');
const LearnerMarksheetIcscAnnualPrint_2_I_III = () => import(/* webpackChunkName: "wws-icsc-annual-print-I-III" */'@/components/WWSExamination/Admin/LearnerMarksheetIcscAnnualPrint_2_I_III');
const PrintAnnualResultBulkIToIII = () => import(/* webpackChunkName: "wws-icsc-annual-bulk-print-I-III" */'@/components/WWSExamination/Admin/PrintAnnualResultBulkIToIII');
const PrintAnnualResultBulkIPriPrim = () => import(/* webpackChunkName: "wws-icsc-annual-bulk-print-pri-primary" */'@/components/WWSExamination/Admin/PrintAnnualResultBulkIPriPrim');
const PrintAnnualResultBulkIVToX = () => import(/* webpackChunkName: "wws-icsc-annual-print-IV-X" */'@/components/WWSExamination/Admin/PrintAnnualResultBulkIVToX');
const DESAnnualMarksheet = () => import(/* webpackChunkName: "des-template-marksheet" */'@/components/Examination/Admin/DESAnnualMarksheet');



const Marksheet = () => import(/* webpackChunkName: "sgs-xi-marksheet" */'@/components/SanjivaniExamination/Admin/Marksheet');
const AnnualMarksheet = () => import(/* webpackChunkName: "sgs-xi-annual-marksheet" */'@/components/SanjivaniExamination/Admin/AnnualMarksheet');
const CBSEAnnualMarksheet = () => import(/* webpackChunkName: "sgs-cbse-annual-marksheet" */'@/components/SanjivaniExamination/Admin/CBSEAnnualMarksheet');
const HPCReportCard = () => import(/* webpackChunkName: "hpc-marksheet" */'@/components/SanjivaniExamination/Admin/HPCReportCard');
const SaisaAnnualMarksheet = () => import(/* webpackChunkName: "saisa-cbse-annual-marksheet" */'@/components/Examination/Admin/SaisaAnnualMarksheet');

// const P2C = () => import(/* webpackChunkName: "P2C" */'@/components/TryNError/ParentChild');
// const LS = () => import(/* webpackChunkName: "LS" */'@/components/TryNError/LS');
// const TestTraining = () => import(/* webpackChunkName: "test-training" */'@/components/TryNError/TestTraining');

const ViewDownloadApplicationForm = () => import(/* webpackChunkName: "view-application-form" */'@/components/Admission/ViewDownloadApplicationForm');
const AddmissionFormUwws = () => import(/* webpackChunkName: "view-application-form-uwws" */'@/components/Admission/AdmissionFormView/AddmissionFormUwws');
const AddmissionFormVvp = () => import(/* webpackChunkName: "view-application-form-vvp" */'@/components/Admission/AdmissionFormView/AddmissionFormVvp');
const AddmissionFormZeal = () => import(/* webpackChunkName: "view-application-form-zeal" */'@/components/Admission/AdmissionFormView/AddmissionFormZeal');
const AddmissionFormWws = () => import(/* webpackChunkName: "view-application-form-wws" */'@/components/Admission/AdmissionFormView/AddmissionFormWws');
const AdmissionFormSanjivani = () => import(/* webpackChunkName: "view-application-form-sanjivani" */'@/components/Admission/AdmissionFormView/AdmissionFormSanjivani');
const AdmissionFormEPS = () => import(/* webpackChunkName: "view-application-form-eps" */'@/components/Admission/AdmissionFormView/AdmissionFormEPS');
const AdmissionFormSbpps = () => import(/* webpackChunkName: "view-application-form-sbpps" */'@/components/Admission/AdmissionFormView/AdmissionFormSbpps');
const AdmissionFormTMV = () => import(/* webpackChunkName: "view-application-form-tmv" */'@/components/Admission/AdmissionFormView/AdmissionFormTMV');
const AssociateTemplate = () => import(/* webpackChunkName: "associate-template" */'@/components/Admission/ElectiveAdmission/AssociateTemplate');

const SalarySlipPrint = () => import(/* webpackChunkName: "print-pay-slip" */'@/components/Payroll/Employee/SalarySlipPrint');
const SalarySlipSanjivaniPrint = () => import(/* webpackChunkName: "print-pay-slip-sanjivani" */'@/components/Payroll/Employee/SalarySlipSanjivaniPrint');
const StudentFeesInvoicePrint = () => import(/* webpackChunkName: "learner-fees-invoice-print" */'@/components/AccountingAndFees/OfficeStaff/StudentFeesInvoicePrint');
const RefundReceiptPrint = () => import(/* webpackChunkName: "refund-receipt-print" */'@/components/AccountingAndFees/OfficeStaff/RefundReceiptPrint');
const AddManagementUsers = () => import(/* webpackChunkName: "add-management-users" */'@/components/Management/AddManagementUsers');
const BypassManagementInst = () => import(/* webpackChunkName: "bypass-management-inst" */'@/components/Management/BypassManagementInst');

const ViewInvoice = () => import(/* webpackChunkName: "view-invoice-edustore" */'@/components/EduStore/Parent/ViewInvoice.vue');
const BulkLearnerMarksheet = () => import(/* webpackChunkName: "bulk-learner-marksheet" */'@/components/Examination/Admin/BulkLearnerMarksheet.vue');
const SettlementReport = () => import(/* webpackChunkName: "settlement-report" */'@/components/Management/AccountingAndFees/SettlementReport.vue');
const OutstandingFeeReport = () => import(/* webpackChunkName: "outstanding-fee-report" */'@/components/Management/AccountingAndFees/OutstandingFeeReport.vue');
const FeeReconcilliationReport = () => import(/* webpackChunkName: "fee-reconcilliation-report" */'@/components/Management/AccountingAndFees/FeeReconcilliationReport.vue');

const routes = [
    // {
    //     path: '/abc',
    //     name: 'abc',
    //     component: TestTraining
    // },
    {
        path: '/s2t',
        name: 's2t',
        component: S2T,
    },
    {
        path: '/css',
        name: 'css',
        component: CSS,
    },
    // {
    //     path: '/ls',
    //     name: 'ls',
    //     component: LS,
    // },
    // {
    //     path: '/p2c',
    //     name: 'p2c',
    //     component: P2C,
    // },
    // {
    //     path: '/mobile-share',
    //     name: 'mobile-share',
    //     component: MobileShare,
    // },
    {
        path: '/view-invoice-edustore',
        name: 'view-invoice-edustore',
        component: ViewInvoice,
    },
    {
        path: '/zeal-lc-print',
        name: 'zeal-lc-print',
        component: ZealLCPrint,
    },
    {
        path: '/vvp-lc-print',
        name: 'vvp-lc-print',
        component: VvpLCPrint,
    },
    {
        path: '/wws-lc-print',
        name: 'wws-lc-print',
        component: WWSLCPrint,
    },
    {
        path: '/faculty-time-table',
        name: 'faculty-time-table',
        component: FacultyTimeTable1,
    },

    {
        path: '/des-lc-print',
        name: 'des-lc-print',
        component: DesLCPrint,
    },
    {
        path: '/print-lc-template',
        name: 'print-lc-template',
        component: PrintLCTemplate,
    },
    {
        path: '/sak-lc-print',
        name: 'sak-lc-print',
        component: SakLCPrint,
    },
    {
        path: '/sav-lc-print',
        name: 'sav-lc-print',
        component: SavLCPrint,
    },
    {
        path: '/sjcv-lc-print',
        name: 'sjcv-lc-print',
        component: SjcvLCPrint,
    },
    {
        path: '/sjck-lc-print',
        name: 'sjck-lc-print',
        component: SjckLCPrint,
    },
    {
        path: '/ssjc-lc-print',
        name: 'ssjc-lc-print',
        component: SsjcLCPrint,
    },
    {
        path: '/sis-lc-print',
        name: 'sis-lc-print',
        component: SisLCPrint,
    },
    {
        path: '/sbpps-lc-print',
        name: 'sbpps-lc-print',
        component: SbppsLCPrint,
    },
    {
        path: '/eps-lc-print',
        name: 'eps-lc-print',
        component: EPSLCPrint,
    },
    {
        path: '/bulk-lc-print',
        name: 'bulk-lc-print',
        component: BulkLCTemplatePrint,
    },
    {
        path: '/zeal-inst-card-print',
        name: 'zeal-inst-card-print',
        component: ZealInstructorCardPrint,
    },
    {
        path: '/inst-card-print',
        name: 'inst-card-print',
        component: CommonInstructorIcardPrint,
    },
    {
        path: '/tmv-inst-card-print',
        name: 'tmv-inst-card-print',
        component: TMVInstructorIcardPrint,
    },
    {
        path: '/sanjivani-inst-card-print',
        name: 'sanjivani-inst-card-print',
        component: SanjivaniInstructorCardPrint,
    },
    {
        path: '/sanjivani-student-bulk-card-print',
        name: 'sanjivani-student-bulk-card-print',
        component: SanjivaniStudentBulkIcardPrint,
    },
    {
        path: '/sbpps-student-bulk-card-print',
        name: 'sbpps-student-bulk-card-print',
        component: SbppsStudentBulkIcardPrint,
    },
    {
        path: '/sbpps-inst-bulk-card-print',
        name: 'sbpps-inst-bulk-card-print',
        component: SbppsInstructorBulkIcardPrint,
    },
    {
        path: '/sbpps-inst-specific-card-print',
        name: 'sbpps-inst-specific-card-print',
        component: SbppsInstructorSpecificIcardPrint,
    },
    {
        path: '/zeal-inst-bulk-card-print',
        name: 'zeal-inst-bulk-card-print',
        component: ZealInstructorBulkIcard,
    },
    {
        path: '/sanjivani-inst-bulk-card-print',
        name: 'sanjivani-inst-bulk-card-print',
        component: SanjivaniInstructorBulkIcard,
    },
    {
        path: '/zeal-stud-bulk-card-print',
        name: 'zeal-stud-bulk-card-print',
        component: ZealStudentBulkICardPrint,
    },//
    {
        path: '/wws-stud-bulk-escort-print',
        name: 'wws-stud-bulk-escort-print',
        component: WwsStudentBulkEscortPrint,
    },//WwsStudentBulkEscortPrint
    {
        path: '/zeal-specific-card-print',
        name: 'zeal-specific-card-print',
        component: ZealStudentSpecificICardPrint,
    },
    {
        path: '/sbpps-specific-parent-card-print',
        name: 'sbpps-specific-parent-card-print',
        component: SbppsParentSpecificIcardPrint,
    },
    {
        path: '/sanjivani-specific-icard-print',
        name: 'sanjivani-specific-icard-print',
        component: SanjivaniStudentSpecificIcardPrint,
    },
    {
        path: '/wws-stud-escort-print',
        name: 'wws-stud-escort-print',
        component: WwsStudentEscortPrint,
    },
    {
        path: '/uwws-bulk-icard-print',
        name: 'uwws-bulk-icard-print',
        component: UwwsStudentBulkIcardPrint,
    },
    {
        path: '/uwws-specific-card-print',
        name: 'uwws-specific-card-print',
        component: UwwsStudentSpecificIcardPrint,
    },
    {
        path: '/uwws-parent-bulk-card-print',
        name: 'uwws-parent-bulk-card-print',
        component: UwwsParentBulkIcardPrint,
    },
    {
        path: '/uwws-parent-specific-card-print',
        name: 'uwws-parent-specific-card-print',
        component: UwwsParentSpecificIcardPrint,
    },
    {
        path: '/wws-father-icard-print',
        name: 'wws-father-icard-print',
        component: WwsFatherIcardPrint,
    },
    {
        path: '/wws-mother-icard-print',
        name: 'wws-mother-icard-print',
        component: WwsMotherIcardPrint,
    },
    {
        path: '/wws-stud-new-bulk-card-print',
        name: 'wws-stud-new-bulk-card-print',
        component: WwsStudentBulkIcardPrint,
    },
    {
        path: '/vvp-stud-bulk-card-print',
        name: 'vvp-stud-bulk-card-print',
        component: VVPStudentBulkIcardPrint,
    },
    {
        path: '/wws-stud-new-specific-card-print',
        name: 'wws-stud-new-specific-card-print',
        component: WwsStudentSpecificIcardPrint,
    },
    {
        path: '/sbpps-stud-specific-card-print',
        name: 'sbpps-stud-specific-card-print',
        component: SbppsStudentSpecificIcardPrint,
    },
    {
        path: '/vvp-stud-specific-card-print',
        name: 'vvp-stud-specific-card-print',
        component: VVPStudentSpecificIcardPrint,
    },
    {
        path: '/sbpps-bulk-parent-card-print',
        name: 'sbpps-bulk-parent-card-print',
        component: SbppsParentBulkIcardPrint,
    },
    {
        path: '/tmv-bulk-icard-print',
        name: 'tmv-bulk-icard-print',
        component: TMVStudentBulkIcardPrint,
    },
    {
        path: '/tmv-specific-card-print',
        name: 'tmv-specific-card-print',
        component: TMVStudentSpecificIcardPrint,
    },

    //healthcard student-health-card
    {
        path: '/student-health-card',
        name: 'student-health-card',
        component: StudentHealthCard,
    },
    {
        path: '/hallticket-bulk-print',
        name: 'hallticket-bulk-print',
        component: HallticketBulkPrintSJCK
    },
    /////
    {
        path: '/parent-view-form',
        name: 'parent-view-form',
        component: ViewForm,
    },
    {
        path: '/add-visitor',
        name: 'add-visitor',
        component: AddVisitor,
    },
    {
        path: '/visitor-epass',
        name: 'visitor-epass',
        component: VisitorEPass,
    },
    {
        path: '/send-to-mailEpass',
        name: 'send-to-mailEpass',
        component: SendtomailEpass,
    },

    {
        path: '/capture-photo',
        name: 'capture-photo',
        component: CapturePhoto,
    },
    {
        path: '/sbpps-ams',
        name: 'sbpps-ams',
        component: SbppsAnnualMS,
    },
    {
        path: '/sbpps-ams-2',
        name: 'sbpps-ams-2',
        component: SbppsAnnualMS2,
    },
    {
        path: '/sbpps-primary-ms',
        name: 'sbpps-primary-ms',
        component: SbppsLearnetMarksheetOfAdmin,
    },
     {
        path: '/bulk-learner-marksheet',
        name: 'bulk-learner-marksheet',
        component: BulkLearnerMarksheet,
    },
    {
        path: '/sbpps-primary-ms-parent',
        name: 'sbpps-primary-ms-parent',
        component: SbppsLearnetMarksheetOfParent,
    },
    {
        path: '/sbpps-hsc-ms-parent',
        name: 'sbpps-hsc-ms-parent',
        component: ParentLearnerMarksheetHSC,
    },
    {
        path: '/sbpps-preprimary-ms-parent',
        name: 'sbpps-preprimary-ms-parent',
        component: SbppsLearnetMarksheetOfParentPrePrimary,
    },
    {
        path: '/sbpps-preprimary-ms-parent-annual',
        name: 'sbpps-preprimary-ms-parent-annual',
        component: SbppsAnnualReportPrePrimary,
    },
    {
        path: '/sbpps-preprimary-ms-parent-annual-2',
        name: 'sbpps-preprimary-ms-parent-annual-2',
        component: SbppsAnnualReportPrePrimary2,
    },
    {
        path: '/sbpps-preprimary-ms',
        name: 'sbpps-preprimary-ms',
        component: SbppsReportPrePrimary,
    },
    {
        path: '/sbpps-secondary-ams',
        name: 'sbpps-secondary-ams',
        component: SbppsAnnualReportSecondary,
    },
    {
        path: '/sbpps-secondary-ams-22-23',
        name: 'sbpps-secondary-ams-22-23',
        component: AnnualReportSecondary_22_23,
    },
    {
        path: '/sbpps-secondary-ams-xi',
        name: 'sbpps-secondary-ams-xi',
        component: AnnualReportXI,
    },
    {
        path: '/sbpps-primary-hsc',
        name: 'sbpps-primary-hsc',
        component: LearnerMarksheetHSC,
    },
    {
        path: '/wws-primary-ms-print',
        name: 'wws-primary-ms-print',
        component: LearnerMarksheetIsceITOIII,
    },
    {
        path: '/icse-pri-sec-marksheet',
        name: 'icse-pri-sec-marksheet',
        component: MarksheetICSE,
    },
    {
        path: '/learner-marksheet-icse-pre-prim-print',
        name: 'learner-marksheet-icse-pre-prim-print',
        component: LearnerMarksheetPrePrimIcsePrint,
    },
    {
        path: '/learner-annual-marksheet-icse-pre-prim-view',
        name: 'learner-annual-marksheet-icse-pre-prim-view',
        component: LearnerAnnualMarksheetPrePrimIcseView,
    },
    {
        path: '/learner-annual-marksheet-icse-pre-prim-print',
        name: 'learner-annual-marksheet-icse-pre-prim-print',
        component: LearnerAnnualMarksheetPrePrimIcsePrint,
    },
    {
        path: '/wws-marathi-print',
        name: 'wws-marathi-print',
        component: LearnerMarksheetMarathiPrint,
    },
    {
        path: '/wws-icsc-annual-print',
        name: 'wws-icsc-annual-print',
        component: LearnerMarksheetIcscAnnualPrint,
    },
    {
        path: '/wws-icsc-annual-print-2',
        name: 'wws-icsc-annual-print-2',
        component: LearnerMarksheetIcscAnnualPrint_2,
    },
    {
        path: '/wws-icsc-annual-view',
        name: 'wws-icsc-annual-view',
        component: LearnerAnnualMarksheetView,
    },
    {
        path: '/wws-icsc-annual-view-I-III',
        name: 'wws-icsc-annual-view-I-III',
        component: LearnerAnnualMarksheetView_I_III,
    },
    {
        path: '/wws-icsc-annual-print-I-III',
        name: 'wws-icsc-annual-print-I-III',
        component: LearnerMarksheetIcscAnnualPrint_2_I_III,
    },
    {
        path: '/wws-icsc-annual-bulk-print-IV-X',
        name: 'wws-icsc-annual-bulk-print-IV-X',
        component: PrintAnnualResultBulkIVToX,
    },
    {
        path: '/des-template-marksheet',
        name: 'des-template-marksheet',
        component: DESAnnualMarksheet,
    },
    {
        path: '/wws-icsc-annual-bulk-print-I-III',
        name: 'wws-icsc-annual-bulk-print-I-III',
        component: PrintAnnualResultBulkIToIII,
    },
    {
        path: '/wws-icsc-annual-bulk-print-pri-primary',
        name: 'wws-icsc-annual-bulk-print-pri-primary',
        component: PrintAnnualResultBulkIPriPrim,
    },
    {
        path: '/sgs-xi-marksheet',
        name: 'sgs-xi-marksheet',
        component: Marksheet,
    },
    {
        path: '/sgs-xi-annual-marksheet',
        name: 'sgs-xi-annual-marksheet',
        component: AnnualMarksheet,
    },
    {
        path: '/sgs-cbse-annual-marksheet',
        name: 'sgs-cbse-annual-marksheet',
        component: CBSEAnnualMarksheet,
    },
    {
        path: '/hpc-marksheet',
        name: 'hpc-marksheet',
        component: HPCReportCard,
    },
    {
        path: '/saisa-cbse-annual-marksheet',
        name: 'saisa-cbse-annual-marksheet',
        component: SaisaAnnualMarksheet,
    },
    {
        path: '/bonafied-wws-print',
        name: 'bonafied-wws-print',
        component: WWSBonafiedPrint
    },//
    {
        path: '/annual-ms',
        name: 'annual-ms',
        component: LearnerMarksheetInfoZeal,
    },
    {
        path: '/view-application-form',
        name: 'view-application-form',
        component: ViewDownloadApplicationForm,
    },
    {
        path: '/view-application-form-uwws',
        name: 'view-application-form-uwws',
        component: AddmissionFormUwws,
    },
    {
        path: '/view-application-form-vvp',
        name: 'view-application-form-vvp',
        component: AddmissionFormVvp,
    },
    {
        path: '/view-application-form-sanjivani',
        name: 'view-application-form-sanjivani',
        component: AdmissionFormSanjivani,
    },
    {
        path: '/view-application-form-zeal',
        name: 'view-application-form-zeal',
        component: AddmissionFormZeal,
    },
    {
        path: '/view-application-form-wws',
        name: 'view-application-form-wws',
        component: AddmissionFormWws,
    },
    {
        path: '/view-application-form-eps',
        name: 'view-application-form-eps',
        component: AdmissionFormEPS,
    },
    {
        path: '/view-application-form-sbpps',
        name: 'view-application-form-sbpps',
        component: AdmissionFormSbpps,
    },
    {
        path: '/view-application-form-tmv',
        name: 'view-application-form-tmv',
        component: AdmissionFormTMV,
    },
    {
        path: '/associate-template',
        name: 'associate-template',
        component: AssociateTemplate,
    },
    {
        path: '/print-pay-slip',
        name: 'print-pay-slip',
        component: SalarySlipPrint,
    },
    {
        path: '/print-pay-slip-sanjivani',
        name: 'print-pay-slip-sanjivani',
        component: SalarySlipSanjivaniPrint,
    },
    {
        path: '/learner-fees-invoice-print',
        name: 'learner-fees-invoice-print',
        component: StudentFeesInvoicePrint
    },
    {
        path: '/refund-receipt-print',
        name: 'refund-receipt-print',
        component: RefundReceiptPrint
    },

    /////////////////////////////////////////
    {
        path: '/check-eps-management-home',
        name: 'check-eps-management-home',
        component: MngtRedirect,
    },
    {
        path: '/management-login',
        name: 'management-login',
        component: MngtLogin,
    },
    // {
    //     path: '/add-management-users', 
    //     name: 'add-management-users ', 
    //     component: AddManagementUsers,
    // },
    // {
    //     path: '/bypass-management-inst', 
    //     name: 'bypass-management-inst', 
    //     component: BypassManagementInst,
    // },
    {
        path: '/eps-management-home',
        name: 'eps-management-home',
        component: MngtHome,
        beforeEnter: ((to, from, next) => {
            if (!localStorage.getItem('Mngt-EPS-token')) next('/management-login')
            else next()
        }),
        children: [
            {
                path: '/mngt-by-pass',
                name: 'mngt-by-pass',
                component: MngtByPass,
            },
            {
                path: '/mngt-faculty-by-pass',
                name: 'mngt-faculty-by-pass',
                component: MngtFacultyBypass,
            },
            {
                path: '/mngt-attendance-report',
                name: 'mngt-attendance-report',
                component: Attendance_Report,
            },
             
              {
                path: '/settlement-report',
                name: 'settlement-report',
                component: SettlementReport,
            },
             {
                path: '/outstanding-fee-report',
                name: 'outstanding-fee-report',
                component: OutstandingFeeReport,
            },
            {
                path: '/fee-reconcilliation-report',
                name: 'fee-reconcilliation-report',
                component: FeeReconcilliationReport,
            },
            {
                path: '/mngt-user-report',
                name: 'mngt-user-report',
                component: User_Report,
            },

           
            {
                path: '/mngt-academics-dashboard-report',
                name: 'mngt-academics-dashboard-report',
                component: Academics_Dashboard,
            },
            {
                path: '/mngt-payment-daily-transaction-report',
                name: 'mngt-payment-daily-transaction-report',
                component: PaymentDailyTransactionReport,
            },
            {
                path: '/mngt-inst-due-report',
                name: 'mngt-inst-due-report',
                component: InstallmentDueReport,
            },
            {
                path: '/mngt-fine-details-report',
                name: 'mngt-fine-details-report',
                component: FineDetailedReport,
            },
            {
                path: '/mngt-emp-leave-balnace-report',
                name: 'mngt-emp-leave-balnace-report',
                component: ManagementEmployeeLeaveBalanceReport,
            },
            {
                path: '/approve-leave',
                name: 'approve-leave',
                component: ApproveLeave,
            },
            {
                path: '/mngt-inst-report',
                name: 'mngt-inst-report',
                component: ManagementInstructorReport,
            },
            {
                path: '/mngt-inst-structure-report',
                name: 'mngt-inst-structure-report',
                component: ManagementInstStructureReport,
            },
            {
                path: '/mngt-student-report-pre-primary-card',
                name: 'mngt-student-report-pre-primary-card',
                component: PrePrimaryStudentReportCard,
            },
            {
                path: '/mngt-student-report-primary-card',
                name: 'mngt-student-report-primary-card',
                component: PrimaryReportCard,
            },
            {
                path: '/mngt-faculty-time-table',
                name: 'mngt-faculty-time-table',
                component: FacultyTimeTable,
            },
            {
                path: '/mngt-weak-time-table-report',
                name: 'mngt-weak-time-table-report',
                component: GetWeakTTReport,
            },
            {
                path: '/mngt-div-time-table',
                name: 'mngt-div-time-table',
                component: DivTimeTable,
            },
            {
                path: '/add-management-users',
                name: 'add-management-users',
                component: AddManagementUsers,
            },
            {
                path: '/bypass-management-inst',
                name: 'bypass-management-inst',
                component: BypassManagementInst,
            },
            {
                path: '/mngt-installment-detailed-report',
                name: 'mngt-installment-detailed-report',
                component: ManagementInstallmentDetailedReport,
            },
            {
                path: '/mngt-section-summary-report',
                name: 'mngt-section-summary-report',
                component: ManagementSectionSummaryReport,
            },
            {
                path: '/mngt-account-dashboard',
                name: 'mngt-account-dashboard',
                component: ManagementAccountDashboard,
            },
        ]
    },

    // new home page
    {
        path: '/eps-management-home2',
        name: 'eps-management-home2',
        component: MngtHome2,
        // children: [
        //     {
        //         path: '/mngt-by-pass', 
        //         name: 'mngt-by-pass', 
        //         component: MngtByPass,
        //     },
        //     {
        //         path: '/mngt-attendance-report', 
        //         name: 'mngt-attendance-report', 
        //         component: Attendance_Report,
        //     },
        //     {
        //         path: '/mngt-user-report', 
        //         name: 'mngt-user-report', 
        //         component: User_Report,
        //     },
        //     {
        //         path: '/mngt-academics-dashboard-report', 
        //         name: 'mngt-academics-dashboard-report', 
        //         component: Academics_Dashboard,
        //     },
        //     {
        //         path: '/mngt-payment-daily-transaction-report', 
        //         name: 'mngt-payment-daily-transaction-report', 
        //         component: PaymentDailyTransactionReport,
        //     },
        //     {
        //         path: '/mngt-emp-leave-balnace-report', 
        //         name: 'mngt-emp-leave-balnace-report', 
        //         component: ManagementEmployeeLeaveBalanceReport,
        //     },
        //     {
        //         path: '/mngt-inst-report', 
        //         name: 'mngt-inst-report', 
        //         component: ManagementInstructorReport,
        //     },
        //     {
        //         path: '/mngt-inst-structure-report', 
        //         name: 'mngt-inst-structure-report', 
        //         component: ManagementInstStructureReport,
        //     },
        //     {
        //         path: '/mngt-student-report-pre-primary-card', 
        //         name: 'mngt-student-report-pre-primary-card', 
        //         component: PrePrimaryStudentReportCard,
        //     },
        //     {
        //         path: '/mngt-student-report-primary-card', 
        //         name: 'mngt-student-report-primary-card', 
        //         component: PrimaryReportCard,
        //     },
        //     {
        //         path: '/mngt-faculty-time-table', 
        //         name: 'mngt-faculty-time-table', 
        //         component: FacultyTimeTable,
        //     },
        //     {
        //         path: '/mngt-div-time-table', 
        //         name: 'mngt-div-time-table', 
        //         component: DivTimeTable,
        //     },
        // ]

    },
    {
        path: '/:catchAll(.*)',
        name: 'NotFound',
        component: NotFound
    },
    // new home page end

]

export default routes